/* eslint-disable camelcase */
import { CREATE_ROLE } from 'constants/drawerTitles';

export const ADMIN_ACCESS = 'd97f1387-a788-4544-be98-a5f4eb915aa3';
export const HIDDEN_ROLES = [
  // SALES_AND_SERVICE
  '09b7952c-db2f-4d26-9a1d-b38dc20c44c0',
  //   ADVANCED
  '9150444d-0eb1-4d53-9f29-67d5150d7da9',
  //   AUTOMATION
  'b006aa82-7fc3-4d90-aaba-b72c65626bbe',
  //   ADMIN_ACCESS
  'd97f1387-a788-4544-be98-a5f4eb915aa3',
];
export const ADMIN_SETTINGS = 'Admin Settings';

export const CREATE_ROLE_OBJ = {
  name: CREATE_ROLE,
  user_defined: true,
};
